import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=42f6ff7a&scoped=true&lang=pug"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f6ff7a",
  null
  
)

export default component.exports